import { render, staticRenderFns } from "./SourcesCopyTo.vue?vue&type=template&id=b9d70a8c&scoped=true"
import script from "./SourcesCopyTo.vue?vue&type=script&lang=js"
export * from "./SourcesCopyTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d70a8c",
  null
  
)

export default component.exports